<template>
  <div id="dashboard">
    <month-task @changeMonth="changeMonthHandler" />
    <div class="row">
      <BrandStatistic :cur-month="curMonth" />
      <Message />
    </div>
    <div class="row">
      <DayOrderInfo />
      <NewOrder />
    </div>
  </div>
</template>
<script>
import DayOrderInfo from './partials/DayOrderInfo.vue'
import MonthTask from './partials/MonthTask.vue'
import NewOrder from './partials/NewOrder.vue'
import Message from './partials/Message.vue'
import BrandStatistic from './partials/BrandStatistic.vue'
import moment from 'moment'
export default {
  name: 'Dashboard',
  components: { MonthTask, NewOrder, DayOrderInfo, Message, BrandStatistic },
  data () {
    return {
      curMonth: moment().format('YYYY-MM')
    }
  },
  methods: {
    changeMonthHandler (month) {
      this.curMonth = month
    }
  }
}
</script>
